import { FeatureDefinitionNext } from '@central-products/bootstrapper';
import {
  AccountInfoInterface,
  AccountInfoStateType,
  AccountInfoState,
  OnAccountInfoStateChangedCallback,
} from '@central-products/interface-account-info';

const FEATURE_NAME = '@feature/anonymous-account-info' as const;

// account-verification-frontend has no CAS session (it is reached via an emailed, token-based
// verification link, not a logged-in page) so there is no real account to report — live-messaging-flow
// requires an `account-info` dependency, and this always-anonymous implementation satisfies it without
// pulling in the full CAS session/GraphQL stack that a real account-info integration would need.
//
// Note: this intentionally does not `extend AccountInfoInterface` — that class is decorated for
// transport-bus binding, which we skip via `bindToTransport: false` below, so a plain class matching
// its public shape is sufficient (and avoids invoking the transport-bus decorated constructor).
const ANONYMOUS_STATE: AccountInfoState = {
  state: AccountInfoStateType.NO_ACCOUNT_INFO,
  accountId: null,
  firstName: null,
  balance: null,
  bonus: null,
  currency: null,
  currencyCode: null,
  country: null,
  countryCode: null,
};

export class AnonymousAccountInfo {
  public async getState(): Promise<AccountInfoState> {
    return ANONYMOUS_STATE;
  }

  public onStateChanged(callback: OnAccountInfoStateChangedCallback): void {
    callback(ANONYMOUS_STATE);
  }
}

export const anonymousAccountInfoFeature: FeatureDefinitionNext<
  typeof FEATURE_NAME,
  Record<string, never>,
  Record<string, never>
> = {
  name: FEATURE_NAME,
  create: () => new AnonymousAccountInfo(),
  implements: AccountInfoInterface,
  bindToTransport: false,
  dependsOn: [],
  role: 'account-info',
};
